<template>
  <div class="w-full">
    <vx-card
      class="collapsed"
      collapseAction
      data-action="collapse"
      :title="diaSemanaNome + ', ' + dia + ' de ' + mes"
    >
      <div
        id="card-forca"
        class="vs-con-loading__container"
        style="min-height: 371px"
      >
        <VuePerfectScrollbar class="scroll-card-forca" :settings="settings">
          <vs-col
            vs-w="12"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
          >
            <div
              v-if="forcaDisponivel"
              style="display: inline-block"
              class="w-full"
            >
              <div v-if="forcaDisponivel != 'feriado'">
                <div v-if="diaSemana == 6 || diaSemana == 0">
                  <vs-col
                    vs-w="12"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                  >
                    <span style="color: #c96b00" class="font-semibold my-5">
                      Este dia cai no fim de semana
                    </span>
                  </vs-col>
                  <vs-divider class="my-0" border-style=""></vs-divider>
                </div>
                <vs-collapse type="" accordion class="my-0 py-0">
                  <span :key="index" v-for="(data, index) in forcaDisponivel">
                    <vs-collapse-item
                      icon-arrow-down
                      style="background-color: #f2f2f2; border-radius: 4px"
                      class="my-1"
                    >
                      <div slot="header">
                        <div class="mx-0 my-0 py-0">
                          <vs-row vs-type="flex" vs-w="12">
                            <div>
                              <strong
                                ><span style="font-size: 16px">{{
                                  data.nome
                                }}</span
                                >:</strong
                              >
                              <br />
                              <span
                                style="font-size: 14px; color: green"
                                v-if="data.status == 1"
                              >
                                {{ data.forca + " horas manutenção" }}
                              </span>
                              <span style="font-size: 14px; color: red" v-else>
                                {{ data.forca + " " + data.status }}
                              </span>
                              ||
                              <span
                                style="font-size: 14px; color: green"
                                v-if="data.statusInicial == 1"
                              >
                                {{ data.forcaInicial + " horas iniciais" }}
                              </span>
                              <span style="font-size: 14px; color: red" v-else>
                                {{
                                  data.forcaInicial + " " + data.statusInicial
                                }}
                              </span>
                              ||
                              <span
                                style="font-size: 14px; color: green"
                                v-if="data.statusCarros == 1"
                              >
                                {{ data.carros + " rotas dispon." }}
                              </span>
                              <span style="font-size: 14px; color: red" v-else>
                                {{ data.carros + " " + data.statusCarros }}
                              </span>
                            </div>
                          </vs-row>
                        </div>
                      </div>
                      <span :key="index2" v-for="(data2, index2) in data.horas">
                        <vs-col vs-w="12" class="my-2">
                          <h6>
                            <strong>
                              <span style="font-size: 18px"
                                >as {{ data2.hora }}h</span
                              >:
                              <br />
                            </strong>
                            <div>
                              <vs-col vs-w="5">
                                <!-- <span v-if="data.status == 1"> -->
                                <span>
                                  <span
                                    class="mr-2"
                                    style="font-size: 14px; color: green"
                                    v-if="data2.status == 1"
                                  >
                                    <span style="font-size: 16px">
                                      <b>
                                        {{ data2.forca }}
                                      </b></span
                                    >
                                    hrs manutenção
                                  </span>
                                  <span
                                    style="font-size: 14px; color: red"
                                    v-else
                                  >
                                    <span style="font-size: 16px">
                                      <b>
                                        {{ data2.forca }}
                                      </b></span
                                    >
                                    {{ data2.status }}
                                  </span>
                                </span>
                                <!-- <span v-else>
                                  *<span style="font-size: 12px; color: red">
                                    {{ data.status }}
                                  </span>
                                </span> -->
                              </vs-col>
                              <vs-col vs-w="4">
                                <!-- <span v-if="data.statusInicial == 1"> -->
                                <span>
                                  <span
                                    class="mr-2"
                                    style="font-size: 14px; color: green"
                                    v-if="data2.statusInicial == 1"
                                  >
                                    <span style="font-size: 16px">
                                      <b>
                                        {{ data2.forcaInicial }}
                                      </b></span
                                    >
                                    horas iniciais
                                  </span>
                                  <span
                                    style="font-size: 14px; color: red"
                                    v-else
                                  >
                                    <span style="font-size: 16px">
                                      <b>
                                        {{ data2.forcaInicial }}
                                      </b></span
                                    >
                                    {{ data2.statusInicial }}
                                  </span>
                                </span>
                                <!-- <span v-else>
                                  *<span style="font-size: 12px; color: red">
                                    {{ data.statusInicial }}
                                  </span>
                                </span> -->
                              </vs-col>
                              <vs-col vs-w="3">
                                <!-- ̣<span v-if="data.statusCarros == 1"> -->
                                <span>
                                  <span
                                    class=""
                                    style="font-size: 14px; color: green"
                                    v-if="data2.statusCarros == 1"
                                  >
                                    <span style="font-size: 16px">
                                      <b>
                                        {{ data2.carros }}
                                      </b></span
                                    >
                                    rotas
                                  </span>
                                  <span
                                    style="font-size: 14px; color: red"
                                    v-else
                                  >
                                    <span style="font-size: 16px">
                                      <b>
                                        {{ data2.carros }}
                                      </b></span
                                    >
                                    {{ data2.statusCarros }}
                                  </span>
                                </span>
                                <!-- <span v-else>
                                  *<span style="font-size: 12px; color: red">
                                    {{ data.statusCarros }}
                                  </span>
                                </span> -->
                              </vs-col>
                            </div>
                          </h6>
                        </vs-col>
                      </span>
                    </vs-collapse-item>
                  </span>
                </vs-collapse>
              </div>
              <div class="con-colors my-5" v-else>
                <ul>
                  <span
                    class="px-3 pt-2"
                    style="color: grey !important; font-weight: 1000 !important"
                    ><vs-icon
                      size="large"
                      icon="sentiment_dissatisfied"
                    ></vs-icon
                  ></span>
                </ul>
                <vs-col
                  vs-w="12"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                >
                  <span style="color: red" class="font-semibold my-5">
                    Este dia é feriado!
                  </span>
                </vs-col>
              </div>
            </div>
            <div v-else>
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-col
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  vs-align="center"
                >
                  <p class="mt-10 pt-10" style="font-size: 30px">
                    Carregando... {{ loading }} %
                  </p>
                </vs-col>
              </vs-row>
            </div>
          </vs-col>
        </VuePerfectScrollbar>
      </div>
    </vx-card>
  </div>
</template>
<script>
import components from "@/components/default/exports.js";
export default {
  props: {
    data: null,
    forcaDataObj: null,
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
        height: 1000,
      },
      dias: [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
      ],
      meses: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
      forcaModal: false,
      forcaDisponivel: null,
      dia: null,
      mes: null,
      diaSemanaNome: null,
      diaSemana: null,
      loading: 0,
    };
  },
  methods: {
    async getDates() {
      this.loading = 25;
      let data = new Date(`${this.data}T12:00:00+0000`);
      this.diaSemanaNome = this.dias[data.getDay()];
      this.diaSemana = data.getDay();
      this.dia = data.getDate();
      this.mes = this.meses[data.getMonth()];
      this.loading += 25;
    },
    async getForcaDisponivel() {
      if (this.forcaDataObj) {
        this.loading = 50;
        this.forcaDisponivel = this.forcaDataObj;
        this.loading = 100;
        return;
      }
      await this.$vs.loading({ container: "#card-forca", scale: 0.6 });
      try {
        this.loading += 25;
        this.forcaDisponivel = await this.$http.post("getForcaDisponivel", {
          data_competencia: this.data,
        });
        this.loading += 25;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$vs.loading.close("#card-forca > .con-vs-loading");
      }
    },
    async getHorasDisponiveis() {
      await this.forcaDisponivel.forEach(async (turno) => {
        let total = 0;
        await turno.horas.forEach(async (hora) => {
          if (hora.status == true) {
            await total++;
          }
        });
        turno.horasDisponiveis = total;
      });
    },
  },
  async mounted() {
    await this.getDates();
    await this.getForcaDisponivel();
  },
  components: { ...components },
};
</script>
<style >
.scroll-card-forca {
  max-height: 75vh !important;
}
</style>
